import { useEffect, useRef } from 'react'
import { useTheme } from '../contexts/ThemeContext'
import { MONDRIAN_MODULES, ROTHKO_MODULES, BLOCKS, THEMES } from '../config/themes'

export default function ThemeWrapper({ children }) {
  const { theme, module, block } = useTheme()
  const wrapperRef = useRef(null)

  const ALL_THEME_CLASSES = [
    'theme-midnight', 'theme-mondrian', 'theme-rothko',
    'theme-chatrone', 'theme-chatrone-dark', 'theme-blocks',
  ]

  useEffect(() => {
    const el = wrapperRef.current
    if (!el) return

    el.classList.remove(...ALL_THEME_CLASSES)
    el.classList.add(`theme-${theme}`)

    if (theme === 'blocks') {
      const b = BLOCKS[block] || BLOCKS.default
      el.style.setProperty('--module-accent', b.accent)
      el.style.setProperty('--module-body-bg', b.bodyBg)
      el.style.setProperty('--module-transition', 'background 0.35s ease')
      el.style.removeProperty('--module-surface-bg')
    } else if (theme === 'mondrian') {
      const m = MONDRIAN_MODULES[module] || MONDRIAN_MODULES.default
      el.style.setProperty('--module-accent', m.accent)
      el.style.setProperty('--module-body-bg', m.bodyBg)
      el.style.removeProperty('--module-surface-bg')
      el.style.removeProperty('--module-transition')
    } else if (theme === 'rothko') {
      const r = ROTHKO_MODULES[module] || ROTHKO_MODULES.default
      el.style.setProperty('--module-accent', r.accent)
      el.style.setProperty('--module-surface-bg', r.bg)
      el.style.setProperty('--module-transition', THEMES.rothko.bgTransition)
      el.style.removeProperty('--module-body-bg')
    } else if (theme.startsWith('chatrone')) {
      // Chatrone themes set --module-accent via CSS; no inline override needed.
      // Just clear the non-applicable variables from other themes.
      el.style.removeProperty('--module-body-bg')
      el.style.removeProperty('--module-surface-bg')
      el.style.removeProperty('--module-transition')
    } else {
      el.style.removeProperty('--module-accent')
      el.style.removeProperty('--module-body-bg')
      el.style.removeProperty('--module-surface-bg')
      el.style.removeProperty('--module-transition')
    }
  }, [theme, module, block])

  return (
    <div ref={wrapperRef} className="theme-wrapper h-full">
      {children}
    </div>
  )
}
